import React from "react";

function BS4_Filters() {
  return (
    <div>
      <h1>BS4_Filters Component</h1>
      <p>This is the BS4_Filters tutorial page content.</p>
    </div>
  );
}

export default BS4_Filters;
